module.exports = __webpack_public_path__ + "img/promo_smartc3.4bbeed3f.png";